// Deeplink vers le message original dans Outlook (nouveau / web).
// Module PUR — pas de Graph, pas de réseau. ms_item_id vient du greffe add-in.

export function graftMsItemId(row: object): string | null {
  const id = 'ms_item_id' in row ? (row as { ms_item_id?: unknown }).ms_item_id : undefined;
  if (typeof id !== 'string') return null;
  const trimmed = id.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function outlookWebHref(msItemId: string): string {
  return `https://outlook.office.com/owa/?ItemID=${encodeURIComponent(msItemId)}&exvsurl=1&viewmodel=ReadMessageItem`;
}

export function outlookAppHref(msItemId: string): string {
  return `ms-outlook://emails/message/open?restID=${encodeURIComponent(msItemId)}`;
}

export function canOpenInOutlook(email: { kind: string; row: object }): boolean {
  return email.kind === 'graft' && graftMsItemId(email.row) !== null;
}

export function openGraftInOutlook(row: object): void {
  const id = graftMsItemId(row);
  if (!id) return;
  window.open(outlookWebHref(id), '_blank', 'noopener,noreferrer');
}
